/**
 * Shared utility for subscription activation
 * This module provides a throttled function to handle subscription activation requests.
 * Due to third-party API limitations, activation must be done through the self-serve portal.
 */

import throttle from 'just-throttle';
import Swal from 'sweetalert2';
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';

/**
 * Throttled function to activate a subscription.
 * Calls the v8ActivateSubscription Firebase function (which triggers an email notification),
 * then displays a SweetAlert informing the user to use the self-serve portal.
 */
const activateSubscription = throttle(async () => {
    console.log("Activating subscription");
    
    // try {
    //     // Call the Firebase function to trigger email notification
    //     const res = await httpsCallable(functions, "v8ActivateSubscription")(authState.subId);
    //     console.log("subscription activation run:", res);
    // } catch (err) {
    //     console.error("Error calling v8ActivateSubscription:", err);
    // }
    
    // Show notification directing user to self-serve portal
    await Swal.fire({
        ...SWAL_BASE,
        titleText: "Activation Failed",
        text: "To activate your subscription, please go to the Help menu and select 'Manage Subscription' to access the self-serve portal. You can also contact support for assistance at support@closedcaptioncreator.com",
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.ok,
    });
}, 10000, { leading: true });

export { activateSubscription };
export default activateSubscription;
